import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'cerebral';
import AppContainer from 'common/appContainer/AppContainer';
import Menu from './Menu';
import { useText } from 'common/hooks';

import Account from 'account/AppDesktop';
import { AppDesktopComponent as Challenge } from 'challenge/AppDesktop';
import { StatusBar } from './elements';

const tools = {
  account: Account,
  challenge: Challenge,
};

const deps = {
  tool: state`app.tool`,
  offline: state`useragent.network.offline`,
};

export function App({
  tool,
  offline,
}: typeof deps & ConnectedProps): React.ReactElement {
  const ToolComponent = tools[tool] || Account;
  const t = useText();

  return (
    <>
      {offline ? (
        <StatusBar text={t('appContainer.network_status_notification')} />
      ) : null}
      <ToolComponent />
    </>
  );
}

const AppComponent = connect(deps, App);

export default function Container({ app }) {
  return (
    <AppContainer app={app}>
      <Menu />
      <AppComponent />
    </AppContainer>
  );
}
